import React, { useEffect, useMemo, useRef, useState } from "react";
import './styles.css';
import axios from "axios";

export interface DeicingSummaryFilterData {
    company?: string | null;
    dateFrom?: string | null;
    dateTo?: string | null;
}

export interface DeicingFormItem {
    type1FluidConsumption: number | null;
    fluidRatio: string | null;
    waterConsumption: number | null;
    note?: string | null;
}

export interface DeicingSummaryFilterDialogWindowProps {
    onCloseDialog?: () => void
    onConfirmDialog?: (data?: DeicingSummaryFilterData) => void
}

const initialFormData = (
): DeicingSummaryFilterData => ({
    company: null,
    dateFrom: null,
    dateTo: null
});

const DeicingSummaryFilterDialogWindow: React.FC<DeicingSummaryFilterDialogWindowProps> = ({ onCloseDialog, onConfirmDialog }) => {

    const [formData, setFormData] = useState<DeicingSummaryFilterData>();
    const [companies, setCompanies] = useState<any[]>([]);

    useEffect(() => {
        loadAirlines();
    }, []);

    const updateField = <K extends keyof DeicingSummaryFilterData>(
        field: K,
        value: DeicingSummaryFilterData[K]
    ) => {
        let updatedFormData;
        setFormData(previous => {
            updatedFormData = {
                ...previous,
                [field]: value
            }
            return updatedFormData;
        });
    };

    const loadAirlines = async () => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/airline/getAll"
                })
            );

            if (res?.data?.airlines?.length > 0) {

                setCompanies(res?.data?.airlines.map(airline => ({ value: airline.id, label: airline.name })));
            }
        } catch (err) {
            throw err;
        }
    }

    return <div className="deice-summary-dialog">
        <div className="deice-summary-dialog-content">
            <div className="deice-summary-dialog-title">
                Přehled (Excel)
            </div>
            <DateTimeField
                label="Datum od"
                value={formData?.dateFrom ?? null}
                onChange={value => updateField("dateFrom", value)}
                onSetCurrentTime={function (): void {
                    throw new Error("Function not implemented.");
                }}
            />
            <DateTimeField
                label="Datum do"
                value={formData?.dateTo ?? null}
                onChange={value => updateField("dateTo", value)}
                onSetCurrentTime={function (): void {
                    throw new Error("Function not implemented.");
                }}
            />
            <SelectField
                label="Společnost"
                value={formData?.company}
                options={companies}
                onChange={value => updateField("company", value)}
            />
            <div className="deice-summary-dialog-buttons">
                <button
                    type="button"
                    className="deice-summary-dialog-close"
                    onClick={onCloseDialog}
                >
                    Zrušit
                </button>
                <button
                    type="button"
                    className="deice-summary-dialog-confirm"
                    onClick={() => onConfirmDialog?.(formData)}
                >
                    Export
                </button>
            </div>
        </div>
    </div>
};

interface NumberFieldProps {
    label: string;
    value: number | null;
    min?: number;
    max?: number;
    onChange: (value: number | null) => void;
    readOnly?: boolean;
}

const NumberField: React.FC<NumberFieldProps> = ({
    label,
    value,
    min,
    max,
    onChange,
    readOnly = false
}) => (
    <label>
        {label}
        <input
            type="number"
            value={value ?? undefined}
            min={min}
            max={max}
            step={1}
            onChange={event =>
                onChange(
                    event.target.value === ""
                        ? null
                        : Number(event.target.value)
                )
            }
            readOnly={readOnly}
        />
    </label>
);

interface Option {
    value: string;
    label: string;
}

interface SelectFieldProps {
    label: string;
    value: string | number | null | undefined;
    options: Option[];
    onChange: (value: string) => void;
    disabled?: boolean;
}

const SelectField: React.FC<SelectFieldProps> = ({
    label,
    value,
    options,
    onChange,
    disabled = false
}) => (
    <label>
        {label}
        <select
            value={value ?? undefined}
            onChange={event => onChange(event.target.value)}
            disabled={disabled}
        >
            <option value="">Vyberte hodnotu</option>

            {options.map(option => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    </label>
);

interface DateTimeFieldProps {
    label: string;
    value: string | null;
    onChange: (value: string | null) => void;
    onSetCurrentTime: () => void;
    disabled?: boolean;
}

const DateTimeField: React.FC<DateTimeFieldProps> = ({
    label,
    value,
    onChange,
    onSetCurrentTime,
    disabled = false,
}) => {
    return (
        <div className="date-time-field">
            <label className="date-time-field__label">
                <span className="date-time-field__label-text">
                    <label>{label}</label>
                </span>

                <input
                    className="date-time-field__input"
                    type="date"
                    value={value ?? ""}
                    disabled={disabled}
                    onChange={event =>
                        onChange(event.target.value || null)
                    }
                />
            </label>

            {/* <button
                className="date-time-field__button"
                type="button"
                disabled={disabled}
                onClick={onSetCurrentTime}
            >
                Nastavit aktuální čas
            </button> */}
        </div>
    );
};

export default DeicingSummaryFilterDialogWindow;